import { connect } from 'react-redux'
import { Dispatch, Action } from 'redux'
import { ContactUsRequest } from 'typescript-fetch-api'

import Component from '../components/ContactUsForm'
import { RootStoreState } from '../../../common/root'
import { UserAccount } from '../../../common/accounts/types'
import { Branch } from '../../../common/showrooms/types'
import { sendContactUs, clearForm } from '../../../common/contactus/actions'
import { getSortedData } from '../../../common/util/functions'

export interface Props {
	loggedIn: boolean
	selectedAccount?: UserAccount
	defaultBranchId?: string
	accounts: UserAccount[]
	branches: Branch[]
	sendingContactUs: boolean
	sendingContactUsError?: Error
	sentContactUs: boolean
}

export interface Actions {
	onSubmitContactUsForm: (reCaptchaToken: string, contactUsRequest: ContactUsRequest) => void,
	clearForm(): void
}

/** Populate the Props from the store state. */
const mapStateToProps = (state: RootStoreState): Props => {
	const approvedAccounts: UserAccount[] = state.accounts.accounts ? state.accounts.accounts.filter(account => account.registrationState === 'approved') : []
	const combinedBranches: Branch[] = state.showrooms.regions.reduce<Branch[]>((data, region) => data.concat(region.branches), [])
	return {
		loggedIn: !!state.auth.authToken,
		selectedAccount: state.order.selectedAccount,
		defaultBranchId: state.order.branchId,
		accounts: approvedAccounts,
		branches: combinedBranches.length > 0 ? getSortedData(combinedBranches, 'name') : [],
		sendingContactUs: state.profile.sendingContactUs,
		sendingContactUsError: state.profile.sendingContactUsError,
		sentContactUs: state.profile.sentContactUs,
	}
}

/** Populate the Actions with the callbacks for the component. */
const mapDispatchToProps = (dispatch: Dispatch<Action>): Actions => ({
	onSubmitContactUsForm: (reCaptchaToken: string, contactUsRequest: ContactUsRequest) => {
		dispatch(sendContactUs.started({ reCaptchaToken, contactUsRequest }))
	},
	clearForm: () => {
		dispatch(clearForm())
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(Component)
